import React from "react";
import { connect } from "react-redux";
import TermsAndConditionsList from "./components/List";

import "./index.css";

const TermsAndConditionsView = props => (
  <div className="dispatch-container">
    <div>
      <TermsAndConditionsList model={"termsandconditions"} />
    </div>
  </div>
);

const mapStateToProps = state => ({
  unauthorized: state.auth.unauthorized,
  fetching: state.dispatch.fetching,
  items: state.dispatch.items,
  selected: state.dispatch.selected
});

export default connect(mapStateToProps)(TermsAndConditionsView);



// WEBPACK FOOTER //
// ./src/containers/TermsAndConditionsView/index.js